module.exports = __webpack_public_path__ + "img/MacBook-Silver.d308186b.png";